import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=505a216d&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505a216d')) {
      api.createRecord('505a216d', component.options)
    } else {
      api.reload('505a216d', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=505a216d&", function () {
      api.rerender('505a216d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24fXGZ4EUs7Gy/JS/comp/openstreetmap.vue"
export default component.exports